import { defineStore } from "pinia";
import { ResponseGroup } from "../responses";
import { Ref, ref } from "vue";
import { ResponseGroupType } from "@/common/interfaces";

export const useResponseStore = defineStore('responseStore', () => {
	const responseGroup: Ref<ResponseGroup | null> = ref(null);

	const loaded: Ref<boolean> = ref(false);

	function clearStore() {
		responseGroup.value = null;
		loaded.value = false;
	}

	function setFromRemote(remoteResponseGroup: ResponseGroupType) {
		responseGroup.value = ResponseGroup.fromRemote(remoteResponseGroup);
	}

	function updateFromRemote(remoteResponseGroup: ResponseGroupType) {
		if (responseGroup.value === null) {
			return;
		}

		responseGroup.value.updateFromRemote(remoteResponseGroup);
	}

	return {
		clearStore,
		setFromRemote, updateFromRemote,
		responseGroup, loaded
	};
});
